export const questionnaires1: Readonly<string> = '1.現在ご自宅・ご家庭にお車を何台保有されていらっしゃいますか。';
export const questionnaires1Answers: Readonly<string[]> = [
  '0台',
  '1台',
  '2台',
  '3台以上',
];

export const questionnaires1Sub1: Readonly<string> = '2.その他にご検討している購入先を教えてください。';
export const questionnaires1Sub1Answers: Readonly<string[]> = [
  'カルモのみご検討中',
  '他社のカーリースサービス',
  '新車ディーラー',
  '中古車ディーラー・販売店',
  'カーシェア・レンタカー',
  'その他',
];

export const questionnaires1Sub2: Readonly<string> = '3.定額カルモくんにお申込みされたきっかけを教えてください。';
export const questionnaires1Sub2Answers: Readonly<string[]> = [
  'サービスの概要が知りたい',
  '見積もりが欲しい',
  '審査が通るか試したい',
  'ネットや電話での商談・対応',
  '1万円台での利用',
  '短期間（3年以内）の利用',
  '納車スピード',
];
export const questionnaires2: Readonly<string> = '4.新しいクルマはいつまでに必要ですか？';
export const questionnaires2Answers: Readonly<string[]> = [
  '1〜2カ月以内',
  '3カ月以内',
  '6カ月以内',
  '急いでいない',
];
export const questionnaires3: Readonly<string> = '他の選択肢を検討していますか？';
export const questionnaires3Answers: Readonly<string[]> = [
  '他は特に検討していない',
  '中古車ディーラーで購入',
  '他のカーリース事業者',
  'その他',
];
export const questionnaires4: Readonly<string> = '5.ご希望のおクルマについて専任スタッフとご相談いただく際、お電話が繋がりやすい時間帯をお教えください。';
export const questionnaires4Answers: Readonly<string[]> = [
  '10時～12時',
  '12時～14時',
  '14時～16時',
  '16時～18時',
  '18時～20時',
];
export const questionnaires5: Readonly<string> = '5.クルマのご相談やお見積もりを希望される時期をお教えください。';
export const questionnaires5Answers: Readonly<string[]> = [
  'できるだけ早く',
  '2週間以内',
  '1ヶ月以内',
  '2ヶ月以内',
  '3ヶ月以内',
  '希望しない',
];
